import React, { Fragment } from "react";
import styled from "styled-components";
import { View, Text, Link, SlideImage } from "./";
import Vimeo from "../components/Vimeo";

const Container = styled(View)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 8px;

  @media (max-width: 720px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 400px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-top: 4px;
  }
`;

const EntryContainer = styled(View)`
  position: relative;
  ${({ orientation }) =>
    orientation === "landscape" ? "grid-column: span 2;" : ""}
  overflow: hidden;
`;

/*
aspect-ratio: ${({ orientation }) =>
    orientation === "landscape" ? "6 / 4" : "3 / 4"};

  @media (max-width: 1300px) {
    height: calc(0.33 * var(--root-width));
  }
*/

const InnerSpace = styled(Link)`
  display: flex;
  justify-content: center;
  position: relative;
  min-height: 100px;
  height: calc(0.31 * var(--root-width));

  @media (max-width: 720px) {
    height: calc(0.44 * var(--root-width));
  }

  @media (max-width: 400px) {
    height: calc(0.63 * var(--root-width));
  }

  background-color: #ddd;
  overflow-x: hidden;
  @media not all and (hover: none) {
    &:hover {
      opacity: 0.7;
    }
  }
  transition: opacity 250ms ease;
`;

const Meta = styled(Text)`
  height: ${({ moreSpace }) => (moreSpace ? 4.2 : 3.4)}em;

  margin-top: 8px;
  @media (max-width: 400px) {
    margin-top: 4px;
  }
  margin-bottom: 10px;
  @media (max-width: 400px) {
    margin-bottom: 6px;
  }
  @media not all and (hover: none) {
    &:hover {
      opacity: 0.7;
    }
  }
  transition: opacity 250ms ease;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default ({ slides, onLinkClick, id, education }) => {
  return (
    <Container id={id}>
      {slides.map((slide) => {
        const orientation =
          slide.width / slide.height > 1 ? "landscape" : "portrait";
        return (
          <EntryContainer
            key={slide.id}
            orientation={orientation}
            onClick={onLinkClick ? (e) => onLinkClick(e, slide.editLink) : null}
            moreSpace={!!slide.profession}
          >
            <InnerSpace
              orientation={orientation}
              to={slide.to}
              {...(education && slide.title && { alt: slide.title })}
            >
              {slide.videoUrl ? (
                <Vimeo
                  background
                  videoLink={slide.videoUrl}
                  style={{
                    minWidth: "500%",
                    height: "100%",
                    backgroundColor: "white",
                    pointerEvents: "none",
                  }}
                />
              ) : (
                <SlideImage slide={slide} />
              )}
            </InnerSpace>
            <Meta pt={1}>
              {slide.category && <Text>{slide.category}</Text>}
              {!education && slide.profession && (
                <Text
                  textStyle="caption"
                  color="#888"
                  style={{ whiteSpace: "nowrap" }}
                  ellipsis
                  pr={2}
                >
                  {slide.profession}
                  {slide.artistProfessions &&
                    slide.artistProfessions.map((profession, index) => (
                      <span key={index}> / {profession}</span>
                    ))}
                </Text>
              )}
              {slide.artists && (
                <Text style={{ whiteSpace: "nowrap" }} ellipsis pr={3}>
                  {slide.artists.map((artist, index) => (
                    <Fragment key={index}>
                      <Link
                        color="black"
                        to={slide.artistLinks[index]}
                        alt={artist}
                      >
                        {artist}
                      </Link>
                      {index < slide.artists.length - 1 && (
                        <Text inline> / </Text>
                      )}
                    </Fragment>
                  ))}
                </Text>
              )}
              {!slide.artists && slide.artist && (
                <Link color="black" ellipsis to={slide.to}>
                  {slide.artist}
                </Link>
              )}
              {slide.albumTitle && (
                <Link
                  textStyle={slide.artist ? "caption" : null}
                  color="black"
                  to={slide.to}
                  block
                  style={{ whiteSpace: "nowrap" }}
                  ellipsis
                >
                  {(() => {
                    const title =
                      slide.keyValues &&
                      slide.keyValues.find(
                        (keyValue) => keyValue.key.name === "title"
                      );
                    return title ? title.value : slide.albumTitle;
                  })()}
                </Link>
              )}
            </Meta>
          </EntryContainer>
        );
      })}
    </Container>
  );
};
